import styled from 'styled-components';

export const StyledExpensesTable = styled.div`
  padding: 40px 0;
  .expenses-record-table {
    border-radius: 25px;
    .table-title {
      border-top-left-radius: 25px;
      border-top-right-radius: 25px;
    }
  }
  #table {
    width: 100%;
    td, td {
      width: auto;
    }
    .js-expense-type {
      input {
        height: 25px;
        &:focus {
          box-shadow: none !important;
        }
      }
    }
  }
`;

export const RecordExpenseStyled = styled.div`
  .DayPickerInput {
    width: 100%;
    z-index: 1000;
  }

  .expensesReportSecondRow {
    border-top: 1px solid var(--bllink-blue);
    margin-top: 25px;
    padding-top: 25px;
  }
  
  .form-bllink {
    display: flex;
    justify-content: space-between;
    .input-item {
      flex-basis: 23%;
    }
  }

  @keyframes fadeIn {
    0% {
      opacity: 0;
      transform: translateY(-2rem);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const StyledPageContainer = styled.div`
  .expenses-total-text {
    font-size: 30px;
  }
  input:disabled {
    pointer-events: none;
    opacity: .65;
  }
  .expenses-total {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .expenses-submit {
    display: flex;
    justify-content: flex-end;
  }
`;